import { useState } from "react";
import {
    useUserDetails,
    useTotalHolidays,
    useLeaves,
    useUser,
    useProjects,
    useGetPermissions,
    useTotal,
    useDepartments
} from "../Use-auth";
import PermissionPopup from "./PermissionPopup";
import AttendanceRangePicker from "./AttendanceRangePicker";
import AttendanceTable from "./AttendanceTable";
import SkeletonPage from "./SkeletonPage ";

export default function Attendance() {
    const { data: user } = useUser();
    const isHRorAdmin = user?.department === "HR" || user?.department === "Admin" || user?.department === "Management";
    const { data: entries = [] } = useUserDetails();
    const { data: totalemployee = [] } = useDepartments();
    const { data: holidaysData, isLoading } = useTotalHolidays();
    const { data: leavesData = [], } = useLeaves(user?.userId, isHRorAdmin);
    const [searchText, setSearchText] = useState("");
    const { data: projects = [], isFetching } = useProjects();
    const { data: existingPermissions, refetch } = useGetPermissions();
    const [employeeStatusFilter, setEmployeeStatusFilter] = useState("Active");

    const [rangeType, setRangeType] = useState("today");
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const isAdmin = user?.department === "Admin";
    const currentUserPermissions = isAdmin
        ? {
            management: {
                attendance_view: true,
            },
            hr: {
                attendance_view: true,
            },
            employees: {
                attendance_view: true,
            },
        }
        : existingPermissions?.find(p => p.userId === user?.userId);

    const canViewHome =
        isAdmin || currentUserPermissions?.management?.attendance_view === true
        || currentUserPermissions?.hr?.attendance_view === true ||
        currentUserPermissions?.employees?.attendance_view === true;

    let startDate = new Date();
    let endDate = new Date();

    switch (rangeType) {
        case "yesterday":
            startDate.setDate(startDate.getDate() - 1);
            endDate = new Date(startDate);
            break;
        case "7 days":
            startDate.setDate(startDate.getDate() - 6);
            break;
        case "30 days":
            startDate.setDate(startDate.getDate() - 29);
            break;
        case "monthly":
            startDate = new Date(selectedYear, selectedDate.getMonth(), 1);
            endDate = new Date(selectedYear, selectedDate.getMonth() + 1, 0);
            break;
        case "yearly":
            startDate = new Date(selectedYear, 0, 1);
            endDate = new Date(selectedYear, 11, 31);
            break;
    }

    const permissionsLoading = !existingPermissions && !isAdmin;

    if (permissionsLoading) {
        return <SkeletonPage />;
    }

    if (!canViewHome) {
        return (
            <div className="relative h-[80vh] overflow-hidden z-1">
                <PermissionPopup />
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <div className="space-y-6">
                <AttendanceRangePicker
                    rangeType={rangeType}
                    setRangeType={setRangeType}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    selectedYear={selectedYear}
                    setSelectedYear={setSelectedYear}
                    searchText={searchText}
                    setSearchText={setSearchText}
                    employeeStatusFilter={employeeStatusFilter}
                    setEmployeeStatusFilter={setEmployeeStatusFilter}
                     loggedInUser={user}
                />

                {isFetching || isLoading ? (
                    <SkeletonPage />
                ) : entries.length === 0 ? (
                    <div className="text-center text-gray-500 py-20 border rounded-lg">
                        No attendance data available for selected range
                    </div>
                ) : (
                    <AttendanceTable
                        entries={entries}
                        holidaysData={holidaysData || []}
                        leavesData={leavesData}
                        rangeType={rangeType}
                        startDate={startDate}
                        endDate={endDate}
                        selectedYear={selectedYear}
                        searchText={searchText}
                        projects={projects}
                        totalemployee={totalemployee}
                        loggedInUser={user}
                        employeeStatusFilter={employeeStatusFilter}
                    />
                )}
            </div>

        </div>
    );
}
